import { useEffect, useState } from "react";
import { Container, Typography, Button, CircularProgress, Box } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";

const API_BASE_URL = "https://2epfk2ien9.execute-api.eu-west-2.amazonaws.com/prd";

function SubscriptionSuccess() {
    const navigate = useNavigate();
    const location = useLocation();
    const sessionId = new URLSearchParams(location.search).get("session_id");

    // ✅ 사용자 정보 상태값
    const [userInfo, setUserInfo] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (sessionId) {
            fetch(`${API_BASE_URL}/get-subscription-info?session_id=${sessionId}`)
                .then(response => response.json())
                .then(data => {
                    setUserInfo(data);
                    setLoading(false);
                })
                .catch(error => {
                    console.error("❌ Error fetching subscription info:", error);
                    setError("Failed to load subscription details.");
                    setLoading(false);
                });
        }
    }, [sessionId]);

    return (
        <Container maxWidth="sm" style={{ textAlign: "center", marginTop: "40px", padding: "20px" }}>
            <Typography variant="h4" fontWeight="bold" gutterBottom>
                🎉 Subscription Successful!
            </Typography>

            {loading ? (
                <CircularProgress />
            ) : error ? (
                <Typography variant="body1" color="error">{error}</Typography>
            ) : (
                <Box mt={3}>
                    <Typography variant="body1" paragraph>
                        Thank you for your purchase. Your subscription is now active.
                    </Typography>

                    <Box display="flex" flexDirection="column" gap={1} textAlign="left">
                        <Typography variant="body2"><strong>Email:</strong> {userInfo.email}</Typography>
                        <Typography variant="body2"><strong>Phone:</strong> {userInfo.country_code} {userInfo.phone_number}</Typography>
                        <Typography variant="body2"><strong>Subscription Start Date:</strong> {userInfo.subscription_requested_start_date}</Typography>
                        <Typography variant="body2"><strong>Native Language:</strong> {userInfo.native_language.toUpperCase()}</Typography>
                        <Typography variant="body2"><strong>Preferred Language:</strong> {userInfo.preferred_language.toUpperCase()}</Typography>
                    </Box>

                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => navigate("/")}
                        sx={{
                            marginTop: "30px",
                            padding: "12px",
                            fontSize: "16px",
                            width: "100%",
                            borderRadius: "8px"
                        }}
                    >
                        Go to Home
                    </Button>
                </Box>
            )}
        </Container>
    );
}

export default SubscriptionSuccess;
